import { teamTypes } from "redux/Ldb/types/teamTypes";

const initialState = {
    // Team members list
    fetchingTeamMembers: false,
    fetchedTeamMembersSuccess: null,
    fetchedTeamMembersFailure: null,

    // Team members list v2
    fetchingTeamMembers2: false,
    fetchedTeamMembers2Success: null,
    fetchedTeamMembers2Failure: null,
};

export const team = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        // Team members list
        case teamTypes.FETCH_TEAM_MEMBERS_REQUEST:
            return {
                ...state,
                fetchingTeamMembers: true,
                fetchedTeamMembersSuccess: null,
                fetchedTeamMembersFailure: null,
            };
        case teamTypes.FETCH_TEAM_MEMBERS_SUCCESS:
            return {
                ...state,
                fetchingTeamMembers: false,
                fetchedTeamMembersSuccess: action.payload,
                fetchedTeamMembersFailure: null,
            };
        case teamTypes.FETCH_TEAM_MEMBERS_FAILURE:
            return {
                ...state,
                fetchingTeamMembers: false,
                fetchedTeamMembersSuccess: null,
                fetchedTeamMembersFailure: action.payload,
            };

        // Team members list v2
        case teamTypes.FETCH_TEAM_MEMBERS2_REQUEST:
            return {
                ...state,
                fetchingTeamMembers2: true,
                fetchedTeamMembers2Success: null,
                fetchedTeamMembers2Failure: null,
            };
        case teamTypes.FETCH_TEAM_MEMBERS2_SUCCESS:
            return {
                ...state,
                fetchingTeamMembers2: false,
                fetchedTeamMembers2Success: action.payload,
                fetchedTeamMembers2Failure: null,
            };
        case teamTypes.FETCH_TEAM_MEMBERS2_FAILURE:
            return {
                ...state,
                fetchingTeamMembers2: false,
                fetchedTeamMembers2Success: null,
                fetchedTeamMembers2Failure: action.payload,
            };

        // Reset actions
        case teamTypes.RESET_FETCH_TEAM_MEMBERS:
            return {
                ...state,
                fetchingTeamMembers: false,
                fetchedTeamMembersSuccess: null,
                fetchedTeamMembersFailure: null,
            };
        case teamTypes.RESET_FETCH_TEAM_MEMBERS2:
            return {
                ...state,
                fetchingTeamMembers2: false,
                fetchedTeamMembers2Success: null,
                fetchedTeamMembers2Failure: null,
            };

        default:
            return state;
    }
};
